export default __webpack_public_path__ + "static/media/microsoft-todo.9555c0f1.png";